import { Component, OnInit } from '@angular/core';
import { GroupPriceByOrganizationIdDto } from 'src/app/core/api/models';

import { GroupPricesService } from 'src/app/core/api/services/group-prices.service';
import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { GroupPriceDetailsFormComponent } from "../group-price-details-form/group-price-details-form.component";
import { GroupPriceSocialMediaDetailFormComponent } from "../group-price-social-media-detail-form/group-price-social-media-detail-form.component";
import { InternationalGroupPriceComponent } from "../international-group-price/international-group-price.component";


@Component({
    selector: 'app-my-group-price-details',
    templateUrl: './my-group-price-details.component.html',
    styleUrls: ['./my-group-price-details.component.scss'],
    imports: [BaseFormModule, GroupPriceDetailsFormComponent, GroupPriceSocialMediaDetailFormComponent, InternationalGroupPriceComponent]
})
export class MyGroupPriceDetailsComponent
  extends BasePageComponent
  implements OnInit
{
  groupPriceDetail: GroupPriceByOrganizationIdDto = {};

  constructor(
    //protected permissionService: PermissionService,
    protected groupPricesService: GroupPricesService // protected elementRef: ElementRef, // protected loggerService: LoggerService
  ) {
    super();
  }

  ngOnInit() {
    this.loading = false;
    this.title = 'pages.myGroupPriceDetails.title';
  }

  ngAfterViewInit(): void {
    this.getOwnerGroupPricesApi();
  }

  //#region Api

  getOwnerGroupPricesApi() {
    this.unSubs();

    this.loading = true;

    this.groupPricesService
      .groupPricesGetOwnerGroupPrices({ body: {} })
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        this.groupPriceDetail = res.data;
      });
  }

  //#endregion

  onReset() {
    if (this.loading) return;
    this.getOwnerGroupPricesApi();
  }

  scrollToSocialMediaDetail() {
    const socialMediaDetails = document.getElementById('socialMediaDetails');
    socialMediaDetails.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }
}
